var map = {
	"./msb/logo.png": "Mrwn",
	"./smart/logo.png": "VZHI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bUDS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenant ^\.\/.*\/logo\.png$
// module id = bUDS
// module chunks = 1